import request from '../utils/request';
import baseApi from './baseApi';

export function getSupport(params) {
  return request({
    url: `/support`,
    method: 'get',
    data: params,
  });
}

export function sendSupport(params) {
  return request({
    url: `/support/support`,
    method: 'post',
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    data: params,
  });
}

export function getStreamActivity(params, signal) {
  return request({
    url: `/events/streamActivity`,
    method: 'get',
    data: params,
    signal,
  });
}

export function getStreamActivityEventNames(params) {
  return request({
    url: '/events/streamActivity/eventNames',
    method: 'get',
    data: params,
  });
}

const playerApi = baseApi.injectEndpoints({
  endpoints: builder => ({
    getAvailableDateRange: builder.query({
      query: ({ restaurantUuid }) => ({
        url: '/events/streamActivity/available-date-ranges',
        method: 'GET',
        data: { restaurantUuid },
      }),
    }),
  }),
});

export const {
  useGetAvailableDateRangeQuery: useGetAvailableDateRange,
} = playerApi;

export default playerApi;
